import { useParams } from 'react-router';
import { z, type ZodIssueOptionalMessage } from 'zod';

/** {@link useZodParams} is a helper for parsing route params with zod schemas. */
export function useZodParams<T extends Record<string, z.ZodTypeAny>>(paramsSchema: T) {
  return z.object(paramsSchema).parse(useParams(), {
    errorMap: (issue: ZodIssueOptionalMessage) => {
      const failingRouteParamName = issue.path[0];

      return { message: `Expected ${failingRouteParamName ? `\`${failingRouteParamName}\` ` : ''}route param` };
    },
  });
}
